import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './components/dashboard/Dashboard';
import { Planner } from './components/planner/Planner';
import { Trainings } from './components/trainings/Trainings';
import { Instructors } from './components/instructors/Instructors';
import { CRM } from './components/crm/CRM';
import { Reports } from './components/reports/Reports';
import { Login } from './components/auth/Login';
import { RoleSelect } from './components/auth/RoleSelect';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SlipbaanPlanner } from './components/slipbaanplanner/SlipbaanPlanner';
import { TrainingWizard } from './components/training-wizard/TrainingWizard';
import { MyTrainings } from './components/instructor/MyTrainings';
import { MyAvailability } from './components/instructor/MyAvailability';
import { MyNotes } from './components/instructor/MyNotes';
import { UserManagement } from './components/admin/UserManagement';
import { RouteGuard } from './components/auth/RouteGuard';
import { AttendanceRegistration } from './components/instructor/AttendanceRegistration';
import { LocationRoute } from './components/instructor/LocationRoute';
import { SickReport } from './components/instructor/SickReport';
import { Conflicts } from './components/planner/Conflicts';
import { CustomerActivity } from './components/manager/CustomerActivity';
import { Feedback } from './components/manager/Feedback';
import { InstructorSchedule } from './components/schedule/InstructorSchedule';
import { PlannerSchedule } from './components/schedule/PlannerSchedule';
import { ManagerInsights } from './components/dashboard/ManagerInsights';
import { ServiceDetail } from './components/training/ServiceDetail';
import './styles/globals.css';
// Main application component
export function App() {
  return <AuthProvider data-id="element-0">
      <AppRoutes data-id="element-1" />
    </AuthProvider>;
}
// Routes component that handles authentication state
function AppRoutes() {
  const {
    isAuthenticated,
    role,
    isDemoUser
  } = useAuth();
  // If not authenticated, show login
  if (!isAuthenticated) {
    return <Login data-id="element-2" />;
  }
  // Main application with role-based routing
  return <Router data-id="element-3">
      <Layout data-id="element-4">
        <Routes data-id="element-5">
          {/* Common routes for all roles */}
          <Route path="/dashboard" element={role === 'manager' ? <ManagerInsights data-id="element-7" /> : <Dashboard data-id="element-8" />} data-id="element-6" />
          {/* Planner routes */}
          <Route path="/planner" element={<RouteGuard allowedRoles={['planner', 'manager']} data-id="element-10">
                <PlannerSchedule data-id="element-11" />
              </RouteGuard>} data-id="element-9" />
          <Route path="/trainings" element={<RouteGuard allowedRoles={['planner', 'manager']} data-id="element-13">
                <Trainings data-id="element-14" />
              </RouteGuard>} data-id="element-12" />
          <Route path="/instructors" element={<RouteGuard allowedRoles={['planner', 'manager']} data-id="element-16">
                <Instructors data-id="element-17" />
              </RouteGuard>} data-id="element-15" />
          <Route path="/crm" element={<RouteGuard allowedRoles={['planner', 'manager']} data-id="element-19">
                <CRM data-id="element-20" />
              </RouteGuard>} data-id="element-18" />
          <Route path="/track-planning" element={<RouteGuard allowedRoles={['planner']} data-id="element-22">
                <SlipbaanPlanner data-id="element-23" />
              </RouteGuard>} data-id="element-21" />
          <Route path="/training-wizard" element={<RouteGuard allowedRoles={['planner']} data-id="element-25">
                <TrainingWizard data-id="element-26" />
              </RouteGuard>} data-id="element-24" />
          <Route path="/conflicts" element={<RouteGuard allowedRoles={['planner']} data-id="element-28">
                <Conflicts data-id="element-29" />
              </RouteGuard>} data-id="element-27" />
          {/* Manager routes */}
          <Route path="/reports" element={<RouteGuard allowedRoles={['manager']} data-id="element-31">
                <Reports data-id="element-32" />
              </RouteGuard>} data-id="element-30" />
          <Route path="/user-management" element={<RouteGuard allowedRoles={['manager']} data-id="element-34">
                <UserManagement data-id="element-35" />
              </RouteGuard>} data-id="element-33" />
          <Route path="/customer-activity" element={<RouteGuard allowedRoles={['manager']} data-id="element-37">
                <CustomerActivity data-id="element-38" />
              </RouteGuard>} data-id="element-36" />
          <Route path="/feedback" element={<RouteGuard allowedRoles={['manager']} data-id="element-40">
                <Feedback data-id="element-41" />
              </RouteGuard>} data-id="element-39" />
          {/* Instructor routes */}
          <Route path="/my-trainings" element={<RouteGuard allowedRoles={['instructor']} data-id="element-43">
                <MyTrainings data-id="element-44" />
              </RouteGuard>} data-id="element-42" />
          <Route path="/attendance" element={<RouteGuard allowedRoles={['instructor']} data-id="element-46">
                <AttendanceRegistration data-id="element-47" />
              </RouteGuard>} data-id="element-45" />
          <Route path="/locations" element={<RouteGuard allowedRoles={['instructor']} data-id="element-49">
                <LocationRoute data-id="element-50" />
              </RouteGuard>} data-id="element-48" />
          <Route path="/availability" element={<RouteGuard allowedRoles={['instructor']} data-id="element-52">
                <MyAvailability data-id="element-53" />
              </RouteGuard>} data-id="element-51" />
          <Route path="/notes" element={<RouteGuard allowedRoles={['instructor']} data-id="element-55">
                <MyNotes data-id="element-56" />
              </RouteGuard>} data-id="element-54" />
          <Route path="/sick-report" element={<RouteGuard allowedRoles={['instructor']} data-id="element-58">
                <SickReport data-id="element-59" />
              </RouteGuard>} data-id="element-57" />
          <Route path="/schedule" element={<RouteGuard allowedRoles={['instructor']} data-id="element-61">
                <InstructorSchedule data-id="element-62" />
              </RouteGuard>} data-id="element-60" />
          {/* Common routes for all roles */}
          <Route path="/service/:serviceId" element={<ServiceDetail data-id="element-64" />} data-id="element-63" />
          {/* Redirect to role-appropriate default page */}
          <Route path="*" element={<Navigate to="/dashboard" replace data-id="element-66" />} data-id="element-65" />
        </Routes>
      </Layout>
    </Router>;
}